// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"305":"2ad52aac","594":"5beed4ec"}[chunkId] + ".js";
};